jQuery(function () {
    var stepOne = $('.onboarding-step-one');
    var stepTwo = $('.onboarding-step-two');
    var progressbar = $('.progressbar li');
    var columnWrapper = $('.onboarding-column-wrapper');
    var currentYear = (new Date).getFullYear();
    var checkboxContainer = $('.ts-member-confirmation-checkbox');
    var checkboxConfirmError = '<label id="Member_Confirmation-error" class= "text-danger" for= "Member_Confirm-Password" >Du måste godkänna villkoren</label>';
    $('#onboarding-next-step').on('click', function () {
        if ($('#House_YearBuilt').valid() === false) {
            return;
        }
        stepOne.toggle();
        stepTwo.toggle();
        columnWrapper.toggleClass('step-two');
        progressbar.toggleClass('active');
    });
    $('#onboarding-previous-step').on('click', function () {
        stepOne.toggle();
        stepTwo.toggle();
        columnWrapper.toggleClass('step-two');
        progressbar.toggleClass('active');
    });
    $('#onboarding-submit').on('click', function (e) {
        if (!$('#Member_confirmation').is(':checked')) {
            var errorMessage = checkboxContainer.find('#Member_Confirmation-error');
            if (errorMessage.length < 1) {
                checkboxContainer.append(checkboxConfirmError);
            }
            e.preventDefault();
            return;
        }
    });
    $('#Member_confirmation').change(function () {
        var errorMessage = checkboxContainer.find('#Member_Confirmation-error');
        if (this.checked) {
            if (errorMessage.length > 0) {
                errorMessage.remove();
            }
        }
        else {
            checkboxContainer.append(checkboxConfirmError);
        }
    });
    $('#demoaccount-onboarding-form').validate({
        errorClass: 'text-danger',
        rules: {
            'House.YearBuilt': {
                required: true,
                number: true,
                min: 1000,
                max: currentYear
            },
            'MemberEmail': {
                required: true,
                email: true
            },
            'MemberPassword': {
                required: true,
                minlength: 7,
                maxlength: 100
            },
            'MemberConfirmPassword': {
                required: true,
                equalTo: '#Member_Password'
            }
        },
        messages: {
            'House.YearBuilt': {
                required: 'Fältet är obligatoriskt',
                number: 'Ogiltigt årtal. Årtalet ska anges med 4 siffror och vara mindre än eller lika med innevarande år',
                min: 'Ogiltigt årtal. Årtalet ska anges med 4 siffror och vara mindre än eller lika med innevarande år',
                max: 'Ogiltigt årtal. Årtalet ska anges med 4 siffror och vara mindre än eller lika med innevarande år'
            },
            'MemberEmail': {
                required: 'Fältet är obligatoriskt',
                email: 'Det angivna värdet är ingen giltig e-postadress'
            },
            'MemberPassword': {
                required: 'Fältet är obligatoriskt',
                minlength: 'Lösenordet måste vara minst 7 och max 100 tecken långt',
                maxlength: 'Lösenordet måste vara minst 7 och max 100 tecken långt'
            },
            'MemberConfirmPassword': {
                required: 'Fältet är obligatoriskt',
                equalTo: 'Lösenordet och lösenordsbekräftelsen matchar inte'
            }
        }
    });
});
